<div class="w-100">
    <div class="page-info">
        <h3 style="margin: 25px; font-weight: 500; font-size:25px; color: #2a457a;">Analytics</h3>
    </div>
</div>

<div class="table-container" style="margin-left: 20px; margin-right: 20px;">
    <div class="w-100 border-p">
        <div class="mt-10 w-100">
            <!-- Financial Year -->
            <mat-form-field class="w-20 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Financial Year</mat-label>
                <mat-select matNativeControl required [(ngModel)]="l_formData.finyearmstId">
                    <mat-select-trigger>
                        {{ lFN_GetFinancialYearText(l_formData.finyearmstId) }}
                    </mat-select-trigger>
                    <mat-option *ngFor="let l_financialyear of l_financialYearList"
                        [value]="l_financialyear.finyearmstId">
                        <div class="option-container">
                            <span>{{ l_financialyear.finyear }}</span>
                            <ng-container *ngIf="l_financialyear.status">
                                <mat-icon class="active-icon">check_circle</mat-icon>
                            </ng-container>
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <!-- From Date - To Date -->
            <mat-form-field class="w-20 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">From Date - To Date</mat-label>
                <mat-date-range-input [rangePicker]="picker">
                    <input matStartDate matInput placeholder="Start date" [(ngModel)]="l_formData.fromDate"/>
                    <input matEndDate matInput placeholder="End date" [(ngModel)]="l_formData.toDate"/>
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>     
            <!-- Mini FAB -->
            <!-- <button mat-fab class="custom-mini-fab" [title]="'Pull Analytics Data'" (click)="lFN_PullDashboardData();">
                <mat-icon>label_important</mat-icon>
            </button> -->
            <button mat-raised-button color="primary" class="custom-button-blue" (click)="lFN_PullDashboardData();">
                View Analytical Details
            </button>
            <button mat-raised-button color="primary" class="custom-button-blue" (click)="lFN_ViewReportData('summary');">
                View Summary Report
            </button>
            <mat-slide-toggle class="w-20 pl-20 mt-20" [checked]="l_isJsym" (change)="lFN_OnToggleChange($event)">
                <mat-label class="custom-mat-label">{{ l_txnTypeLabel }}</mat-label>
            </mat-slide-toggle>
        </div>
    </div>
    <div class="w-100 border-p mt-10">
        <div class="mt-10 w-100">
            <!-- Category name -->
            <mat-form-field class="w-30 pl-20 " appearance="outline">
                <mat-label class="custom-mat-label">Txncategory</mat-label>
                <mat-select matNativeControl required [(ngModel)]="l_formData.txncategoryId">
                    <mat-option *ngFor="let l_category of l_categoryList" [value]="l_category.txncategoryId">
                        {{ l_category.name }}</mat-option>
                </mat-select>
            </mat-form-field>

            <button mat-raised-button color="primary" class="custom-button-blue" (click)="lFN_ViewReportData('detailed');">
                View Detailed Report
            </button>
        </div>
    </div>
</div>

<div class="dashboard-container">
    <div class="row">
        <!-- Card 2: txnCountJsym -->
        <mat-card class="dashboard-card card-style-2">
            <mat-card-header>
                <mat-card-title class="card-title">Total Count</mat-card-title>
                <mat-card-subtitle class="card-subtitle">Transactions via Razorpay</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="card-content-app">
                <p>{{ l_dashboardData.txnCountJsym }}</p>
            </mat-card-content>
        </mat-card>

        <!-- Card 1: txnAmountJsym -->
        <mat-card class="dashboard-card card-style-1">
            <mat-card-header>
                <mat-card-title class="card-title">Total Amount</mat-card-title>
                <mat-card-subtitle class="card-subtitle">Transactions via Razorpay</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="card-content-app">
                <p>{{ '₹ ' + l_UtilityService.lFN_FormatCurrencyForDisplay(l_dashboardData.txnAmountJsym) }}</p>
            </mat-card-content>
        </mat-card>

        <!-- Card 4: txnCountTaam -->
        <mat-card class="dashboard-card card-style-4">
            <mat-card-header>
                <mat-card-title class="card-title">Total Count</mat-card-title>
                <mat-card-subtitle class="card-subtitle">Transactions via Mandal Receipts</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="card-content-app">
                <p>{{ l_dashboardData.txnCountTaam }}</p>
            </mat-card-content>
        </mat-card>        

        <!-- Card 3: txnAmountTaam -->
        <mat-card class="dashboard-card card-style-3">
            <mat-card-header>
                <mat-card-title class="card-title">Total Amount</mat-card-title>
                <mat-card-subtitle class="card-subtitle">Transactions via Mandal Receipts</mat-card-subtitle>
            </mat-card-header>
            <mat-card-content class="card-content-app">
                <p>{{ '₹ ' + l_UtilityService.lFN_FormatCurrencyForDisplay(l_dashboardData.txnAmountTaam) }}</p>
            </mat-card-content>
        </mat-card>
    </div>

    <div class="dashboard-background">
        <div class="title-header">Category wise Receipt Entry Summary</div>
        <div class="row">
            <!-- Card 5: Donation -->
            <mat-card class="dashboard-card card-style-5">
                <mat-card-header>
                    <mat-card-title class="card-title">Donation</mat-card-title>
                    <div class="icon-container">
                        <mat-icon>money</mat-icon> <!-- Icon for Donation -->
                    </div>
                </mat-card-header>
                <mat-card-content class="card-content">
                    <p>Count: {{ l_dashboardData.donationCount }}</p>
                    <p>Amount: {{ '₹ ' + l_UtilityService.lFN_FormatCurrencyForDisplay(l_dashboardData.donationAmount) }}</p>
                </mat-card-content>
            </mat-card>
    
            <!-- Card 6: Yogprakash -->
            <mat-card class="dashboard-card card-style-6">
                <mat-card-header>
                    <mat-card-title class="card-title">Yogprakash</mat-card-title>
                    <div class="icon-container">
                        <mat-icon>library_books</mat-icon> <!-- Icon for Yogprakash -->
                    </div>
                </mat-card-header>
                <mat-card-content class="card-content">
                    <p>Count: {{ l_dashboardData.yogprakashCount }}</p>
                    <p>Amount: {{ '₹ ' + l_UtilityService.lFN_FormatCurrencyForDisplay(l_dashboardData.yogprakashAmount) }}</p>
                </mat-card-content>
            </mat-card>
    
            <!-- Card 7: Books -->
            <mat-card class="dashboard-card card-style-7">
                <mat-card-header>
                    <mat-card-title class="card-title">Books</mat-card-title>
                    <div class="icon-container">
                        <mat-icon>book</mat-icon> <!-- Icon for Books -->
                    </div>
                </mat-card-header>
                <mat-card-content class="card-content">
                    <p>Count: {{ l_dashboardData.booksCount }}</p>
                    <p>Amount: {{ '₹ ' + l_UtilityService.lFN_FormatCurrencyForDisplay(l_dashboardData.booksAmount) }}</p>
                </mat-card-content>
            </mat-card>
    
            <!-- Card 8: Pariksha -->
            <mat-card class="dashboard-card card-style-8">
                <mat-card-header>
                    <mat-card-title class="card-title">Pariksha</mat-card-title>
                    <div class="icon-container">
                        <mat-icon>school</mat-icon> <!-- Icon for Pariksha -->
                    </div>
                </mat-card-header>
                <mat-card-content class="card-content">
                    <p>Count: {{ l_dashboardData.parikshaCount }}</p>
                    <p>Amount: {{ '₹ ' + l_UtilityService.lFN_FormatCurrencyForDisplay(l_dashboardData.parikshaAmount) }}</p>
                </mat-card-content>
            </mat-card>
        </div>
    </div>    
</div>

